module.exports = __webpack_public_path__ + "img/Simulation-Roof.e3bfc3b3.jpeg";